import { Users, Zap, Leaf, Sparkles, CalendarClock } from "lucide-react";
import { WHY_CHOOSE_US } from "../../lib/constants";

const ICONS = { Users, Zap, Leaf, Sparkles, CalendarClock };

export const WhyChooseUs = () => {
  return (
    <section
      data-testid="why-choose-us"
      className="py-20 md:py-28 bg-slate-50/60 border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-700">
              Why Choose Us
            </div>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-light text-slate-900">
              A standard you can{" "}
              <span className="font-medium">feel the moment you walk in.</span>
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              We treat every home and workspace like our own. From eco-friendly
              products to a meticulous final walk-through — every detail matters.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {WHY_CHOOSE_US.map((w, i) => {
              const Icon = ICONS[w.icon] || Sparkles;
              return (
                <div
                  key={i}
                  data-testid={`why-item-${i}`}
                  className="group relative bg-white border border-slate-100 rounded-2xl p-7 shadow-3d hover:shadow-3d-hover gradient-border tilt-card transition-all duration-500 overflow-hidden"
                >
                  <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-gradient-to-br from-blue-500/10 to-sky-400/10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="relative w-12 h-12 rounded-xl bg-gradient-to-br from-blue-600 to-sky-500 text-white flex items-center justify-center shadow-glow-soft group-hover:shadow-glow-blue transition-all duration-500">
                    <Icon className="w-5 h-5" strokeWidth={1.8} />
                    <span className="absolute inset-0 rounded-xl ring-1 ring-white/30" />
                  </div>
                  <h3 className="mt-5 font-display text-lg font-medium text-slate-900">
                    {w.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                    {w.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
